import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_thriveit-preview/artifacts/xidnz9yy_PNG-02%20%282%29.png';
const CALENDLY_URL = 'https://calendly.com/satyam-thriveitmedia/discovery-call';

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#0a0a0a] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" data-testid="footer-logo">
              <img src={LOGO_URL} alt="Thriveit Media Logo" className="h-10 w-auto mb-5" />
            </Link>
            <p className="text-[#888880] text-sm font-body font-light leading-relaxed">
              Content that looks real. And performs.
            </p>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-heading font-bold text-[#FF5C35] mb-6">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" data-testid="footer-about" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body">About</Link></li>
              <li><Link to="/blog" data-testid="footer-blog" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body">Blog</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-heading font-bold text-[#FF5C35] mb-6">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services/influencer-marketing" data-testid="footer-influencer" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body">Influencer Marketing</Link></li>
              <li><Link to="/services/ai-ugc-ads" data-testid="footer-ai-ugc" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body">AI UGC Ads</Link></li>
              <li><Link to="/services/real-ugc" data-testid="footer-real-ugc" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body">Real UGC</Link></li>
              <li><Link to="/services/social-media-content" data-testid="footer-social-media" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body">Social Media Content</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-heading font-bold text-[#FF5C35] mb-6">Connect</h4>
            <ul className="space-y-3">
              <li>
                <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-calendly" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body inline-flex items-center gap-1">
                  Book a Free Call <ArrowUpRight className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a href="mailto:satyam@thriveitmedia.in" data-testid="footer-email" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body">
                  satyam@thriveitmedia.in
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/satyamdokania/" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body inline-flex items-center gap-1">
                  LinkedIn <ArrowUpRight className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/aiagencyman/?hl=en" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="text-sm text-[#888880] hover:text-[#F5F5F0] transition-colors font-body inline-flex items-center gap-1">
                  Instagram <ArrowUpRight className="w-3 h-3" />
                </a>
              </li>
              <li className="text-sm text-[#888880] font-body">Bengaluru, India</li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#888880] font-body">&copy; 2026 Thriveit Media | thriveitmedia.in | Bengaluru, Karnataka, India</p>
        </div>
      </div>
    </footer>
  );
};
